<template>
  <div>
    <form-fields v-if="entity !== null" :form-config="formConfig" :entity="entity">
      <template #button>
        <b-button
            variant="primary" v-on:click="updateFunction"
            class="mb-1 mb-sm-0 mr-0 mr-sm-1"
            :block="$store.getters['app/currentBreakPoint'] === 'xs'"
        >
          Save Changes
        </b-button>
      </template>
    </form-fields>
    <!-- Action Buttons -->

  </div>
</template>

<script>
//
import {
  BButton,
} from 'bootstrap-vue'

import FormFields from './FormFields'
import {ref} from '@vue/composition-api'
import store from '@/store'
import {FormConfig, FieldType} from '../common/index.d.ts'
import userStore from './storeModule'

const {onUnmounted} = require("@vue/composition-api");
import {useRouter} from '@core/utils/utils'
import {useToast} from "vue-toastification/composition";
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default {

  components: {
    BButton,
    FormFields

  },
  props: {
    formConfig: {
      type: FormConfig,
      required: true,
    },
    entityId: {
      type: [Number, String],
      required: true,
    },
  },
  setup(props) {
    const toast = useToast();
    const entity = ref(null);
    let conf = props.formConfig;
    let r = {
      FieldType,
      entity,
      console,
    };
    let router = useRouter().router;
    console.log(router);
    const formConfig = props.formConfig
    const USER_APP_STORE_MODULE_NAME = `app-edit-${formConfig.entity}`
    if (!store.hasModule(USER_APP_STORE_MODULE_NAME)) {

      console.log(`registerModule ${USER_APP_STORE_MODULE_NAME}`)
      store.registerModule(USER_APP_STORE_MODULE_NAME, userStore(formConfig))

      onUnmounted(() => {
        if (store.hasModule(USER_APP_STORE_MODULE_NAME)) {
          console.log(`unregisterModule ${USER_APP_STORE_MODULE_NAME}`)

          store.unregisterModule(USER_APP_STORE_MODULE_NAME)
        }
      })
    } else {
      console.log(`already register ${USER_APP_STORE_MODULE_NAME}`)
    }
    const updateFunction = (e) => {

      store.dispatch(`${USER_APP_STORE_MODULE_NAME}/update${conf.entity}`, {id: props.entityId, body: entity.value})
          .then(response => {
            toast({
              component: ToastificationContent,
              position: 'bottom-right',
              props: {
                title: `${props.formConfig.entity} Updated`,
                icon: 'CheckIcon',
                variant: 'success',
              },
            })
            router.back();
          })
          .catch(error => {
            console.log(error);
          })
    };

    r.updateFunction = updateFunction;

    store.dispatch(`${USER_APP_STORE_MODULE_NAME}/get${conf.entity}`, {id: props.entityId})
        .then(response => {
          let res = response.data.data
          console.log(res);
          for (const [key, value] of Object.entries(res)) {
            if (value instanceof Array && value !== undefined) {
              let arr = [];
              for (let i = 0; i < value.length; i++) {
                arr.push(value[i].id);
              }
              if (key.endsWith("ies")) {
                res[key.replaceAll("ies", "y_ids")] = arr;
              } else {
                res[key.substring(0, key.length - 1) + "_ids"] = arr;
              }
            } else if (value instanceof Object && value !== undefined) {
              console.log(key);
              res[key + "_id"] = value.id;
            }
          }
          entity.value = res;
        })
        .catch(error => {
          if (error.response.status === 404) {
            entity.value = undefined
          }
        })
    return r;
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
@import '~@core/scss/base/bootstrap-extended/variables';
@import 'bootstrap/scss/variables';
@import '~@core/scss/base/components/variables-dark';
@import '@core/scss/vue/libs/vue-flatpicker.scss';
</style>

<style>
.height-200 {
  height: 200px
}

.my-editor {
  /* we dont use `language-` classes anymore so thats why we need to add background and text color manually */
  background: #2d2d2d;
  color: #ccc;

  /* you must provide font-family font-size line-height. Example:*/
  font-family: Fira code, Fira Mono, Consolas, Menlo, Courier, monospace;
  font-size: 14px;
  line-height: 1.5;
  padding: 5px;
}

.my-editor pre {
  color: white;
}

/* optional class for removing the outline */
.prism-editor__textarea:focus {
  outline: none;
}
</style>

